/* eslint-disable global-require */
module.exports = ['payments.informations.form.fields.phone.m1'];
